"use strict";

const _ = require("lodash");
const GridColumn = require("./column/GridColumnComponent");
const UnlockedGridRow = require("./row/unlocked_row/UnlockedGridRowComponent");
const UnlockedGridGroupRow = require("./row/unlocked_row/UnlockedGridGroupRowComponent");
const LockedGridRow = require("./row/locked_row/LockedGridRowComponent");
const LockedGridGroupRow = require("./row/locked_row/LockedGridGroupRowComponent");
// const BrowserDetect = require('@gluenetworks/srvc_core_browser-detect');
const ScrollbarSizeDetectionUtility = require("@gluenetworks/dom_utilities").Scroll
    .ScrollbarSizeDetectionUtility;
const ElementResizeDetectionUtility = require("@gluenetworks/dom_utilities").Resize
    .ElementResizeDetectionUtility;
const DynamicStylesheetUtility = require("@gluenetworks/dom_utilities").Style
    .DynamicStylesheetUtility;

class EntityGridRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("entity-grid-gl");
        this._rootElem.component = this._model;
        this._gridContainer = document.createElement("grid-container");
        this._lockedColumnContainer = document.createElement("locked-column-container");
        this._lockedColumnContainer.classList.add("column-container");
        this._columnContainer = document.createElement("column-container");
        this._columnContainer.classList.add("column-container");
        this._lockedHeaderRow = document.createElement("header-row");
        this._headerRow = document.createElement("header-row");
        this._lockedGridBodyContainer = document.createElement("grid-body-container");
        this._gridBodyContainer = document.createElement("grid-body-container");
        this._lockedGridBody = document.createElement("grid-body");
        this._gridBody = document.createElement("grid-body");
        this._infoLine = document.createElement("grid-info-line");
        this._emptyMessage = this._createEmptyMessage();

        //Right group Only Container
        this._lockedRightColumnContainer = document.createElement("locked-right-column-container");
        this._lockedRightColumnContainer.classList.add("column-container");
        this._lockedRightHeaderRow = document.createElement("header-row");
        this._lockedRightGridBodyContainer = document.createElement("grid-body-container");
        this._lockedRightGridBody = document.createElement("grid-body");
        //End

        this._lockedGridBodyContainer.appendChild(this._lockedGridBody);
        this._lockedColumnContainer.appendChild(this._lockedHeaderRow);
        this._lockedColumnContainer.appendChild(this._lockedGridBodyContainer);
        this._gridBodyContainer.appendChild(this._gridBody);
        this._columnContainer.appendChild(this._headerRow);
        this._columnContainer.appendChild(this._gridBodyContainer);

        //Right group Only Container
        this._lockedRightGridBodyContainer.appendChild(this._lockedRightGridBody);
        this._lockedRightColumnContainer.appendChild(this._lockedRightHeaderRow);
        this._lockedRightColumnContainer.appendChild(this._lockedRightGridBodyContainer);
        //End

        this._gridContainer.appendChild(this._lockedColumnContainer);
        this._gridContainer.appendChild(this._columnContainer);
        this._gridContainer.appendChild(this._lockedRightColumnContainer);
        this._rootElem.appendChild(this._gridContainer);
        this._rootElem.appendChild(this._infoLine);
        this._scrollTopPosition = 0;

        this._focusInput = document.createElement("input");
        this._focusInput.classList.add("focus-input");
        this._focusInput.setAttribute("readonly", "");
        this._focusInput.setAttribute("type", "text");
        this._focusInput.setAttribute("style", "width:0;height:0;");

        this._rowHeight = 30;
        this._unlockedColumnsTotalWidth = 0;

        this._columnComponents = {};
        this._rowComponents = {};
        this._lockedRowComponents = {};
        this._lockedRightRowComponents = {};

        this._skeletonLayers = {
            unlocked: document.createElement("skeleton-layer"),
            locked: document.createElement("skeleton-layer"),
            lockedRight: document.createElement("skeleton-layer"),
        };
        this._skeletonTop = undefined;
        this._skeletonRowCount = undefined;
        this._skeletonHideTimeout = undefined;
        this._pendingRowDeletes = undefined;

        this._lastRowSelectionId = undefined;
        this._commandKeyDown = false;
        this._sortColumn = undefined;
        this._sort = undefined;

        this._scrollbarSizeDetectionUtility = new ScrollbarSizeDetectionUtility();
        this._gridElementResizeDetectionUtility = new ElementResizeDetectionUtility();
        this._dynamicStylesheetUtility = new DynamicStylesheetUtility();
        this._linesNumberCmpnt = this._model._linesNumberCmpnt;
        this._columnSettingsCmpnt = this._model._columnSettingsCmpnt;
        this._groupingCmpnt = this._model._groupingCmpnt;
        this._filterComponent = this._model._filterComponent;
        this._advancedFilter = this._model._advancedFilter;

        this._scrollbarHeight = undefined;
        this._headerRebuildTimeout = undefined;
        this._gridBodyAdjustmentTimeout = undefined;
        this._timeoutDuration = 50;

        this._registerListeners();
        this._renderPromise = this.render();

        this._scrollTop = _.debounce(this._scrollTop.bind(this), 0);
        this._scrollBodyLeft = _.debounce(this._scrollBodyLeft.bind(this), 0);
    }

    get _pageSize() {
        return this._model.pagingFeed.pageSize;
    }

    get _activePage() {
        return this._model.pagingFeed.activePage;
    }

    get _firstPage() {
        return this._model.pagingFeed.firstPage;
    }

    get _lastPage() {
        return this._model.pagingFeed.lastPage;
    }

    get _totalEntities() {
        return this._model.getTotalEntities();
    }

    get renderPromise() {
        return this._renderPromise;
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let promiseArray = [];

        this._unregisterListeners();
        this._hideSkeleton();
        for (let colKey in this._columnComponents) {
            if (this._columnComponents.hasOwnProperty(colKey)) {
                this._columnComponents[colKey].removeAllListeners("UserSorted");
                this._columnComponents[colKey].removeAllListeners("UserReordered");
                this._columnComponents[colKey].removeAllListeners("UserLocked");
                this._columnComponents[colKey].removeAllListeners("UserResized");
                promiseArray.push(this._columnComponents[colKey].shutdown());
            }
        }
        for (let rowKey in this._rowComponents) {
            if (this._rowComponents.hasOwnProperty(rowKey)) {
                this._rowComponents[rowKey].removeAllListeners("RowUserSelected");
                this._rowComponents[rowKey].removeAllListeners("RowUserActive");
                this._rowComponents[rowKey].removeAllListeners("RowUserDoubleClicked");
                this._rowComponents[rowKey].removeAllListeners("RowAction");
                promiseArray.push(this._rowComponents[rowKey].shutdown());
            }
        }
        for (let rowKey in this._lockedRowComponents) {
            if (this._lockedRowComponents.hasOwnProperty(rowKey)) {
                this._lockedRowComponents[rowKey].removeAllListeners("RowUserSelected");
                this._lockedRowComponents[rowKey].removeAllListeners("RowUserActive");
                this._lockedRowComponents[rowKey].removeAllListeners("RowUserDoubleClicked");
                this._lockedRowComponents[rowKey].removeAllListeners("RowAction");
                promiseArray.push(this._lockedRowComponents[rowKey].shutdown());
            }
        }
        for (let rowKey in this._lockedRightRowComponents) {
            if (this._lockedRightRowComponents.hasOwnProperty(rowKey)) {
                this._lockedRightRowComponents[rowKey].removeAllListeners();
                promiseArray.push(this._lockedRightRowComponents[rowKey].shutdown());
            }
        }

        if (this._linesNumberCmpnt) {
            promiseArray.push(this._linesNumberCmpnt.shutdown());
        }

        if (this._columnSettingsCmpnt) {
            promiseArray.push(this._columnSettingsCmpnt.shutdown());
        }

        if (this._groupingCmpnt) {
            promiseArray.push(this._groupingCmpnt.shutdown());
        }

        if (this._filterComponent) {
            promiseArray.push(this._filterComponent.shutdown());
        }

        if (this._advancedFilter) {
            promiseArray.push(this._advancedFilter.shutdown());
        }

        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        this._lockedColumnContainer = undefined;
        this._columnContainer = undefined;
        this._lockedHeaderRow = undefined;
        this._headerRow = undefined;
        this._lockedGridBodyContainer = undefined;
        this._gridBodyContainer = undefined;
        this._lockedGridBody = undefined;
        this._gridBody = undefined;

        this._scrollTopPosition = undefined;

        this._rowHeight = undefined;
        this._unlockedColumnsTotalWidth = undefined;

        this._columnComponents = undefined;
        this._rowComponents = undefined;
        this._lockedRowComponents = undefined;

        clearTimeout(this._skeletonHideTimeout);
        this._skeletonHideTimeout = undefined;
        this._skeletonLayers = undefined;
        this._skeletonTop = undefined;
        this._pendingRowDeletes = undefined;

        this._lastRowSelectionId = undefined;
        this._commandKeyDown = undefined;
        this._sortColumn = undefined;
        this._sort = undefined;

        this._lockedRightColumnContainer = undefined;
        this._lockedRightHeaderRow = undefined;
        this._lockedRightGridBodyContainer = undefined;
        this._lockedRightGridBody = undefined;

        this._scrollbarSizeDetectionUtility.shutdown();
        this._gridElementResizeDetectionUtility.shutdown();
        this._dynamicStylesheetUtility.shutdown();

        this._scrollbarHeight = undefined;
        if (!_.isUndefined(this._headerRebuildTimeout)) {
            clearTimeout(this._headerRebuildTimeout);
        }
        this._headerRebuildTimeout = undefined;
        if (!_.isUndefined(this._gridBodyAdjustmentTimeout)) {
            clearTimeout(this._gridBodyAdjustmentTimeout);
        }
        this._gridBodyAdjustmentTimeout = undefined;
        if (!_.isUndefined(this._pagePositionCheckTimeout)) {
            clearTimeout(this._pagePositionCheckTimeout);
        }
        this._pagePositionCheckTimeout = undefined;
        this._timeoutDuration = undefined;

        this._renderPromise = undefined;

        return Promise.all(promiseArray);
    }

    _registerListeners() {
        this._model.addListener("Id", (this._onId = this._onId.bind(this)));
        this._model.addListener("Entities", (this._onEntities = this._onEntities.bind(this)));
        this._model.addListener("AddEntity", (this._onAddEntity = this._onAddEntity.bind(this)));
        //this._model.addListener("UpdateRow",this._onUpdateRow = this._onUpdateRow.bind(this));
        this._model.addListener(
            "DeleteEntity",
            (this._onDeleteEntity = this._onDeleteEntity.bind(this))
        );
        this._model.addListener("Columns", (this._onColumns = this._onColumns.bind(this)));
        this._model.addListener(
            "ColumnWidth",
            (this._onColumnWidth = this._onColumnWidth.bind(this))
        );
        this._model.addListener(
            "ColumnOrder",
            (this._onColumnOrder = this._onColumnOrder.bind(this))
        );
        this._model.addListener(
            "LockedColumns",
            (this._onLockedColumns = this._onLockedColumns.bind(this))
        );
        this._model.addListener("ShowColumn", (this._onShowColumn = this._onShowColumn.bind(this)));
        this._model.addListener("HideColumn", (this._onHideColumn = this._onHideColumn.bind(this)));
        this._model.addListener("ShowHeader", (this._onShowHeader = this._onShowHeader.bind(this)));
        this._model.addListener(
            "SelectedRows",
            (this._onSelectedRows = this._onSelectedRows.bind(this))
        );
        this._model.addListener("Focus", (this._onFocus = this._onFocus.bind(this)));
        this._model.addListener("Blur", (this._onBlur = this._onBlur.bind(this)));
        this._model.addListener(
            "GroupingChanged",
            (this._onUserChangeGrouping = this._onUserChangeGrouping.bind(this))
        );
        this._rootElem.addEventListener(
            "focus",
            (this._onFocusEvent = this._onFocusEvent.bind(this))
        );
        this._rootElem.addEventListener("blur", (this._onBlurEvent = this._onBlurEvent.bind(this)));
        this._gridContainer.addEventListener(
            "wheel",
            (this._onGridContainerWheel = this._onGridContainerWheel.bind(this)),
            true
        );
        this._gridBodyContainer.addEventListener(
            "scroll",
            (this._onGridBodyScroll = this._onGridBodyScroll.bind(this))
        );
        this._lockedGridBodyContainer.addEventListener(
            "scroll",
            (this._onLockedGridBodyScroll = this._onLockedGridBodyScroll.bind(this))
        );

        this._lockedRightGridBodyContainer.addEventListener(
            "scroll",
            (this._onLockedGridBodyScroll = this._onLockedGridBodyScroll.bind(this))
        );

        this._gridElementResizeDetectionUtility.addResizeListener(
            this._rootElem,
            _.throttle((this._onResize = this._onResize.bind(this)), this._timeoutDuration)
        );
        this._focusInput.addEventListener(
            "keydown",
            (this._onKeyDown = this._onKeyDown.bind(this))
        );
        this._focusInput.addEventListener("keyup", (this._onKeyUp = this._onKeyUp.bind(this)));
        this._gridBody.addEventListener("click", (this._keepFocus = this._keepFocus.bind(this)));
        this._lockedGridBody.addEventListener("click", this._keepFocus);
        this._lockedRightGridBody.addEventListener("click", this._keepFocus);
    }

    _unregisterListeners() {
        this._model.removeListener("Id", this._onId);
        this._model.removeListener("Entities", this._onEntities);
        this._model.removeListener("AddEntity", this._onAddEntity);
        //this._model.removeListener("UpdateRow",this._onUpdateRow);
        this._model.removeListener("DeleteEntity", this._onDeleteEntity);
        this._model.removeListener("Columns", this._onColumns);
        this._model.removeListener("ColumnWidth", this._onColumnWidth);
        this._model.removeListener("ColumnOrder", this._onColumnOrder);
        this._model.removeListener("LockedColumns", this._onLockedColumns);
        this._model.removeListener("ShowColumn", this._onShowColumn);
        this._model.removeListener("HideColumn", this._onHideColumn);
        this._model.removeListener("ShowHeader", this._onShowHeader);
        this._model.removeListener("SelectedRows", this._onSelectedRows);
        this._model.removeListener("Focus", this._onFocus);
        this._model.removeListener("Blur", this._onBlur);
        this._model.removeListener(
            "GroupingChanged",
            (this._onUserChangeGrouping = this._onUserChangeGrouping.bind(this))
        );
        this._rootElem.removeEventListener("focus", this._onFocusEvent);
        this._rootElem.removeEventListener("blur", this._onBlurEvent);
        this._gridContainer.removeEventListener("wheel", this._onGridContainerWheel, true);
        this._gridBodyContainer.removeEventListener("scroll", this._onGridBodyScroll);
        this._lockedGridBodyContainer.removeEventListener("scroll", this._onLockedGridBodyScroll);
        this._lockedRightGridBodyContainer.removeEventListener(
            "scroll",
            this._onLockedGridBodyScroll
        );
        this._gridElementResizeDetectionUtility.removeResizeListener(
            this._rootElem,
            this._onResize
        );
        this._focusInput.removeEventListener("keydown", this._onKeyDown);
        this._focusInput.removeEventListener("keyup", this._onKeyUp);
        this._gridBody.removeEventListener("click", this._keepFocus);
        this._lockedGridBody.removeEventListener("click", this._keepFocus);
        this._lockedRightGridBody.removeEventListener("click", this._keepFocus);
    }

    _keepFocus() {
        const focusInput = this._gridBody.getElementsByClassName("focus-input");
        if (focusInput && focusInput[0]) {
            const el = focusInput[0];
            const selection = window.getSelection();
            const range = selection.rangeCount === 0 ? null : selection.getRangeAt(0);
            el.focus({preventScroll: true});

            if (range && range.toString() && this._gridContainer.contains(range.startContainer)) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
    }

    _toggleEmptyMessage(state) {
        if (state) {
            this._showEmptyMessage();
        } else {
            this._hideEmptyMessage();
        }
    }

    _showEmptyMessage() {
        if (!this._gridContainer.contains(this._emptyMessage)) {
            this._gridContainer.appendChild(this._emptyMessage);
        }
    }

    _hideEmptyMessage() {
        if (this._gridContainer.contains(this._emptyMessage)) {
            this._gridContainer.removeChild(this._emptyMessage);
        }
    }

    _createEmptyMessage(noRowsText) {
        noRowsText = "No items match the specified filter criteria";
        const emptyMessage = document.createElement("div");
        emptyMessage.classList.add("empty-message");
        emptyMessage.innerHTML = noRowsText;
        return emptyMessage;
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Clear the grid, by delete all rows
     */
    deleteAllRows() {
        Object.keys(this._rowComponents).map((rowKey) => {
            this._deleteRow(rowKey);
            this._deleteLockedRow(rowKey);
            this._deleteLockedRightRow(rowKey);
        });
        this._hideSkeleton();
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                let scrollbarWidth = this._scrollbarSizeDetectionUtility.getScrollbarWidth(),
                    scrollbarHeight = this._scrollbarSizeDetectionUtility.getScrollbarHeight();
                this._lockedHeaderRow.innerHTML = "";
                this._lockedRightHeaderRow.innerHTML = "";
                this._headerRow.innerHTML = "";
                this._headerRow.style.paddingRight = scrollbarWidth / 10 + "rem";
                this._lockedGridBody.innerHTML = "";
                this._lockedRightGridBody.innerHTML = "";
                this._gridBody.innerHTML = "";
                // input, that used for keep focus in the grid
                this._gridBody.appendChild(this._focusInput);

                this._scrollbarHeight = scrollbarHeight;
                this._setId(this._model.getId());
                this._setColumns(this._model.getColumns());
                // let entities = this._model.getEntities();
                // this._setEntities(entities);
                this._setShowHeader(this._model.getShowHeader());
                this._setSelectedRows(this._model.getSelectedRows());
                if (!_.isUndefined(this._sortColumn)) {
                    let sort = this._columnComponents[this._sortColumn].getSort();
                    this._setGridSorted(this._sortColumn, sort);
                }
                if (this.model._showLinesNumber === true && this._linesNumberCmpnt) {
                    this._infoLine.appendChild(this._linesNumberCmpnt.renderer.rootElement);
                }

                const renderUtils = [];
                if (this._filterComponent) {
                    renderUtils.push(this._filterComponent.render());
                }
                if (this._columnSettingsCmpnt) {
                    renderUtils.push(this._columnSettingsCmpnt.renderer.render());
                }
                if (this._groupingCmpnt) {
                    renderUtils.push(this._groupingCmpnt.render());
                }
                if (this._advancedFilter) {
                    renderUtils.push(this._advancedFilter.render());
                }

                return Promise.all(renderUtils);
            })
            .then(() => {
                const {
                    groupBy,
                    expanded,
                    prevColStatus = {},
                } = this._model._userGridData.getGroupingData();
                if (
                    groupBy &&
                    _.has(this._model.getColumns(), "grouping") &&
                    _.get(this._model.getColumns(), [groupBy, "groupable"], false) &&
                    _.isUndefined(this._model._groupingFieldFromUrl)
                ) {
                    if (prevColStatus) {
                        this._model._prevColStatus = Object(prevColStatus);
                    }
                    return this._model.setGroupBy(groupBy, expanded);
                } else if (!_.isUndefined(this._model._groupingFieldFromUrl)) {
                    this._model._groupingFieldFromUrl = undefined;
                }
            })
            .then(() => {
                this._model._updateColumnsWidth(this.model._userGridData.getColWidth());
                if (this._model._pagingFeed && this._model._pagingFeed.wasPreviouslyInitialized()) {
                    this._model._onRefreshView(this._model._pagingFeed);
                    this._model._onFeedRefreshLinesNumber();
                }
                return Promise.resolve();
            })
            .catch((error) => this._log("renderError", error));
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    scrollToTheRow(rowNumber) {
        //scroll to previous row to make rowNumber visible
        if (rowNumber - 1 >= 0) {
            this._gridBodyContainer.scrollTop = this._rowHeight * rowNumber - 1;
        }
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/

    /**
     * Fired when the id has been updated in the model
     * @param newVal {string}
     * @private
     */
    _onId(newVal) {
        this._setId(newVal);
    }

    /**
     * Fired when the column configuration has been updated in the model
     * @param newVal {object}
     * @private
     */
    _onColumns(newVal) {
        this._setColumns(newVal);
    }

    /**
     * Fired when the column configuration has been updated in the model
     * @param newVal {object}
     * @private
     */
    _onColumnWidth(newVal) {
        this._resizeColumn(newVal);
    }

    /**
     * Fired when the column order has been updated in the model
     * @param newVal {array}
     * @private
     */
    _onColumnOrder(newVal) {
        this._setColumnOrder(newVal);
    }

    /**
     * Fired when the the locked columns have been updated in the model
     * @param newVal {array}
     * @private
     */
    _onLockedColumns(newVal) {
        this._setLockedColumns(newVal);
    }

    /**
     * Fired when a column is to be shown
     * @param columnId {String} - The id of the column to be shown
     * @private
     */
    _onShowColumn(columnId) {
        if (columnId) {
            this._showColumn(columnId);
        }
    }

    /**
     * Fired when a column is to be hidden
     * @param columnId {String} - The id of the column to be hidden
     * @private
     */
    _onHideColumn(columnId) {
        if (columnId) {
            this._hideColumn(columnId);
        }
    }

    /**
     * Fired when the entity collection has been updated in the model
     * @param newEntities {object} - Collection of entities keyed by the id of the entitiy.
     * @private
     */
    _onEntities(newEntities) {
        const feedFilterData = this._model.pagingFeed.getFilterData();
        this._toggleEmptyMessage(
            !_.isEmpty(feedFilterData) && _.isEmpty(newEntities) && !this._model._groupBy
        );

        this._setEntities(newEntities);
    }

    /**
     * Fired when a new entity has been added to the model
     * @param newVal {object}
     * @private
     */
    _onAddEntity(newVal) {
        this._addEntity(newVal);
    }

    /**
     * Fired when an entity has been deleted in the model
     * @param rowKey {string}
     * @private
     */
    _onDeleteEntity(rowKey) {
        this._deleteRow(rowKey);
        this._deleteLockedRow(rowKey);
        this._deleteLockedRightRow(rowKey);
    }

    /**
     * Fired when the selcted rows have been updated in the model
     * @param newVal {array}
     * @private
     */
    _onSelectedRows(newVal) {
        this._setSelectedRows(newVal);
    }

    /**
     * Fired when the display of the header has been updated in the model
     * @param newVal {boolean}
     * @private
     */
    _onShowHeader(newVal) {
        this._setShowHeader(newVal);
    }

    /**
     * Fired when focus has been called in the model
     * @private
     */
    _onFocus() {
        this._setFocus(true);
    }

    /**
     * Fired when blur has been called in the model
     * @private
     */
    _onBlur() {
        this._setFocus(false);
    }

    _onUserChangeGrouping(groupingData) {
        this._updateGroupingColumnHeader(groupingData);
    }

    /**
     * Pass the focus event up to the model
     * @param event {Event}
     * @private
     */
    _onFocusEvent(/*event*/) {
        //this._model._triggerUserFocus(event);
    }

    /**
     * Pass the blur event up to the model
     * @param event {Event}
     * @private
     */
    _onBlurEvent(/*event*/) {
        //this._model._triggerUserBlur(event);
    }

    /**
     * Sync the scroll position of the grid header with the grid body
     */

    /**
     *
     * @param event {WheelEvent} - DOM wheel event
     * @private
     */
    _onGridContainerWheel(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.deltaX) {
            this._scrollBodyLeft(
                this._gridBodyContainer.scrollLeft + Math.round(event.deltaX || 0)
            );
        }
        if (event.deltaY) {
            this._scrollTop(this._scrollTopPosition + Math.round(event.deltaY || 0));
        }
    }

    /**
     *
     * @param event {UIEvent} - Grid Body 'scroll' event
     * @private
     */
    _onGridBodyScroll(event) {
        let scrollData = {
            scrollLeft: event.currentTarget.scrollLeft,
            scrollTop: event.currentTarget.scrollTop,
            event: event,
        };

        this._scrollTop(scrollData.scrollTop);
        this._scrollBodyLeft(scrollData.scrollLeft);

        this._model._triggerUserScrolled(scrollData);
    }

    /**
     *
     * @param event {UIEvent} - Locked Grid Body 'scroll' event
     * @private
     */
    _onLockedGridBodyScroll(event) {
        const scrollTop = event.currentTarget.scrollTop;
        this._scrollTop(scrollTop);
    }

    /**
     * Scrolls Locked and unlocked Grid Bodies synchronously in vertical direction
     * @param scrollTop {number} - scroll top position
     * @private
     */
    _scrollTop(scrollTop) {
        if (this._scrollTopPosition !== scrollTop) {
            this._gridBodyContainer.scrollTop = scrollTop;
            this._lockedGridBodyContainer.scrollTop = scrollTop;
            this._lockedRightGridBodyContainer.scrollTop = scrollTop;
            this._scrollTopPosition = this._gridBodyContainer.scrollTop;
            this._updateSkeletonVisibility(this._scrollTopPosition);
            this._checkPagePosition(this._scrollTopPosition);
        }
    }

    /**
     * Scrolls Grid Body and Grid Body Header in horizontal direction
     * @param scrollLeft {number} - Grid Body 'scrollLeft' value
     * @private
     */
    _scrollBodyLeft(scrollLeft) {
        this._gridBodyContainer.scrollLeft = scrollLeft;
        this._headerRow.scrollLeft = scrollLeft;
    }

    /**
     * Pass the resize event for the grid up to the model
     * @param event {Event}
     * @private
     */
    _onResize(event) {
        let gridBodyWidth = this._gridBodyContainer.clientWidth;
        this._adjustGridBody();
        this._model._triggerGridResized({
            gridBodyWidth: gridBodyWidth,
            event: event,
        });
    }

    /**
     * Catch the command key and keyboard arrows
     * @param event {Event}
     * @private
     */
    _onKeyDown(event) {
        const arrows = {
            UP: 38,
            DOWN: 40,
        };
        const keyCode = event.keyCode;

        if ((this._commandKeyDown || event.ctrlKey) && (keyCode === 65 || keyCode === 97)) {
            // 'A' or 'a'
            this._selectAllRows();
        }

        this._commandKeyDown = keyCode === 91 || keyCode === 93;

        if (keyCode === arrows.UP || keyCode === arrows.DOWN) {
            event.preventDefault();
            this._performArrowsNavigation(keyCode === arrows.UP, event.shiftKey);
        }
    }

    getNextKeyboardSelection(upward, entityOrder, prevRowIndex, cloned = false) {
        let originalOrder;
        if (!cloned) {
            originalOrder = _.cloneDeep({
                rowId: entityOrder[prevRowIndex],
                rowIndex: prevRowIndex,
            });
        } else {
            originalOrder = cloned;
        }
        if (upward) {
            if (
                this._model.rowsClickable(
                    this._model.pagingFeed.getEntityById(entityOrder[prevRowIndex])
                )
            ) {
                return Object.assign(
                    {},
                    {rowId: entityOrder[prevRowIndex], rowIndex: prevRowIndex}
                );
            } else {
                if (prevRowIndex !== 0) {
                    return this.getNextKeyboardSelection(
                        true,
                        entityOrder,
                        prevRowIndex - 1,
                        originalOrder
                    );
                } else {
                    return originalOrder;
                }
            }
        } else {
            if (
                this._model.rowsClickable(
                    this._model.pagingFeed.getEntityById(entityOrder[prevRowIndex])
                )
            ) {
                return Object.assign(
                    {},
                    {rowId: entityOrder[prevRowIndex], rowIndex: prevRowIndex}
                );
            } else {
                if (prevRowIndex !== entityOrder.length - 1) {
                    return this.getNextKeyboardSelection(
                        false,
                        entityOrder,
                        prevRowIndex + 1,
                        originalOrder
                    );
                } else {
                    originalOrder.rowIndex = originalOrder.rowIndex - 1;
                    originalOrder.rowId = entityOrder[prevRowIndex - 1];
                    return originalOrder;
                }
            }
        }
    }

    /**
     * perform grid navigation using keyboard arrows
     * @param upDirection {Boolean}
     * @param withShift {Boolean}
     * @private
     */
    _performArrowsNavigation(upDirection = false, withShift = false) {
        const container = this._gridBodyContainer;
        const visibleArea = container.clientHeight;
        const selectedRows = this._model.getSelectedRows();

        if (!selectedRows.length) {
            return;
        }

        const firstSelectedId = selectedRows[0];
        const lastSelectedId = selectedRows[selectedRows.length - 1];
        let prevRowId = this._lastRowSelectionId;

        const entityOrder = this._model.getEntityOrder();
        const prevRowIndex = entityOrder.indexOf(prevRowId);

        if (prevRowIndex === -1) {
            return;
        }

        let nextRowId;
        let nextRowIndex;
        if (upDirection) {
            if (prevRowIndex === 0) {
                return;
            }

            if (this._model._nonClickableRows) {
                const nextRowDetails = this.getNextKeyboardSelection(
                    true,
                    entityOrder,
                    prevRowIndex - 1
                );
                if (!nextRowDetails) {
                    return;
                }
                nextRowId = nextRowDetails.rowId;
                nextRowIndex = nextRowDetails.rowIndex;
            } else {
                nextRowId = entityOrder[prevRowIndex - 1];
                nextRowIndex = prevRowIndex - 1;
            }
        } else {
            if (prevRowIndex === entityOrder.length - 1) {
                return;
            }

            if (this._model._nonClickableRows) {
                const nextRowDetails = this.getNextKeyboardSelection(
                    false,
                    entityOrder,
                    prevRowIndex + 1
                );
                nextRowId = nextRowDetails.rowId;
                nextRowIndex = nextRowDetails.rowIndex;
            } else {
                nextRowId = entityOrder[prevRowIndex + 1];
                nextRowIndex = prevRowIndex + 1;
            }
        }

        const position = nextRowIndex;
        const nextEntityTopPosition = position * this._rowHeight;
        const nextEntityIsVisible =
            nextEntityTopPosition + this._rowHeight < container.scrollTop + visibleArea &&
            nextEntityTopPosition >= container.scrollTop;

        if (!nextEntityIsVisible) {
            //if row is not visible, scroll container to it
            if (upDirection) {
                container.scrollTop = position * this._rowHeight;
            } else {
                container.scrollTop = position * this._rowHeight - visibleArea + this._rowHeight;
            }
        }

        if (withShift) {
            let selectionRange;

            if (selectedRows.includes(nextRowId)) {
                //going back into selection -- decrease selection
                selectionRange = [
                    upDirection ? nextRowId : lastSelectedId,
                    upDirection ? firstSelectedId : nextRowId,
                ];
            } else {
                //increase selection
                selectionRange = [
                    upDirection ? lastSelectedId : nextRowId,
                    upDirection ? nextRowId : firstSelectedId,
                ];
            }

            this._model.pagingFeedGetRangeSelection(...selectionRange).then(
                (selectRange) => this._setUserSelectedRows(selectRange),
                () => {}
            );
        } else {
            this._setUserSelectedRows(nextRowId);
        }

        this._lastRowSelectionId = nextRowId;
    }

    /**
     * Catch the command key
     * @param event {event}
     * @private
     */
    _onKeyUp(event) {
        if (event.keyCode === 91 || event.keyCode === 93) {
            this._commandKeyDown = false;
        }
    }

    /**
     * Fired when a column has been sorted by the user
     * @param eventData.column {String} - The ID of the column being sorted
     * @param eventData.sort {String} - "asc", "desc", or ""
     * @param eventData.event {Event} - The event that triggered the sort
     * @private
     */
    _onColumnUserSorted(eventData) {
        this._setGridSorted(eventData.column, eventData.sort);
        //Set focus on the focus input element after sorting action fired
        if (this._focusInput) {
            this._focusInput.focus();
        }
    }

    /**
     * Fired when a column has been reordered by the user
     * @param eventData.column {String} - ID of the column being reordered
     * @param eventData.newIndex {Number} - The new index position of the column
     * @private
     */
    _onColumnUserReordered(eventData) {
        let newIndex = eventData.newIndex,
            columnId = eventData.column,
            columnOrder = this._model.getColumnOrder(),
            lockedColumns = this._model.getLockedColumns(),
            unlockedColumns = _.difference(columnOrder, lockedColumns),
            newColumnOrder;
        if (lockedColumns.indexOf(columnId) !== -1) {
            lockedColumns.splice(lockedColumns.indexOf(columnId), 1);
            lockedColumns.splice(newIndex, 0, columnId);
        } else if (unlockedColumns.indexOf(columnId) !== -1) {
            unlockedColumns.splice(unlockedColumns.indexOf(columnId), 1);
            unlockedColumns.splice(newIndex, 0, columnId);
        }
        newColumnOrder = _.concat(lockedColumns, unlockedColumns);
        if (!_.isEqual(newColumnOrder, columnOrder)) {
            delete eventData.newIndex;
            eventData.columnOrder = [];
            newColumnOrder.forEach((col) => {
                eventData.columnOrder.push(col);
            });
            this._model.setColumnOrder(newColumnOrder);
            this._model._triggerUserReordered(eventData);
        }
    }

    /**
     * Fired when a user has locked/unlocked a column
     * @param eventData.column {String} - ID of the column being locked
     * @param eventData.locked {Boolean} - The column's locked state
     * @param eventData.event {Event} - The event that triggered the lock/unlock action
     * @private
     */
    _onColumnUserLocked(eventData) {
        let lockedColumns = this._model.getLockedColumns(),
            locked = eventData.locked,
            columnId = eventData.column;
        if (locked === true) {
            lockedColumns.push(columnId);
        } else {
            lockedColumns.splice(lockedColumns.indexOf(columnId), 1);
        }
        this._model.setLockedColumns(lockedColumns);
    }

    /**
     * Fired when a column has been resized by the user
     * @param eventData - Event data
     * @param eventData.column {String} - The id of the column that has been resized
     * @param eventData.width {Number} - The width in pixels of the column
     * @param eventData.event {Event} - The mouse event that triggered the resize
     * @param noEmit {Boolean} - Don't emit ColumnUserResized grid event
     * @private
     */
    _onColumnUserResized(eventData) {
        this._resizeColumn(eventData);
        this._model._triggerColumnUserResized(eventData);
    }

    /**
     * Fired when the user has selected a row
     * @param rowData {object}
     * @param event {event}
     * @private
     */
    _onRowUserSelected(rowData, event) {
        if (this.model.gridIsUnSelectable) {
            return;
        }
        let selectedRows = this._model.getSelectedRows(),
            currentRowSelectionId = event.currentTarget.component.getId(),
            singleSelect = this._model.getSingleSelect();

        if (singleSelect === true) {
            if (event.ctrlKey === true || this._commandKeyDown === true) {
                // Control/Command Click
                if (selectedRows[0] === currentRowSelectionId) {
                    selectedRows = [];
                } else {
                    selectedRows = [currentRowSelectionId];
                }
            } else {
                selectedRows = [currentRowSelectionId];
            }
        } else {
            if (event.ctrlKey === true || this._commandKeyDown === true) {
                // Control/Command Click
                let selectionExists = false;
                selectedRows.forEach((row, index) => {
                    if (currentRowSelectionId === row) {
                        selectionExists = true;
                        selectedRows.splice(index, 1);
                    }
                });
                if (!selectionExists) {
                    selectedRows.push(currentRowSelectionId);
                }
            } else if (event.shiftKey === true) {
                // Shift Click
                if (
                    currentRowSelectionId === this._lastRowSelectionId ||
                    currentRowSelectionId === selectedRows[0]
                ) {
                    selectedRows = [currentRowSelectionId];
                } else {
                    let firstSelectedItem = currentRowSelectionId;
                    let secondSelectedItem = selectedRows[0]; // use first selected element

                    let rowKeys = this._model.getEntityOrder();
                    let currentItemIndex = rowKeys.indexOf(firstSelectedItem);
                    let firstSelectedItemIndex = rowKeys.indexOf(selectedRows[0]);
                    let previousSelectionIndex = rowKeys.indexOf(this._lastRowSelectionId);
                    // if we deselect from bottom to top
                    if (
                        selectedRows.includes(currentRowSelectionId) &&
                        currentItemIndex > previousSelectionIndex
                    ) {
                        secondSelectedItem = firstSelectedItem;
                        firstSelectedItem = selectedRows[selectedRows.length - 1];
                    } else if (currentItemIndex < firstSelectedItemIndex) {
                        // if current row is higer than the selection, use the last selected element
                        secondSelectedItem = selectedRows[selectedRows.length - 1];
                    }
                    this._model
                        .pagingFeedGetRangeSelection(firstSelectedItem, secondSelectedItem)
                        .then(
                            (selectedRows) => this._setUserSelectedRows(selectedRows),
                            () => {
                                // If rejected, no need to update selectedRows
                            }
                        );
                }
            } else {
                // Regular Click
                selectedRows = [currentRowSelectionId];
            }
        }
        this._lastRowSelectionId = currentRowSelectionId;
        this._setUserSelectedRows(selectedRows);
    }

    _applyNonClickableOnSelection(selectedRows) {
        if (this._model._nonClickableRows) {
            if (Array.isArray(selectedRows)) {
                return selectedRows.filter((id) => {
                    if (this._model.rowsClickable(this._model.pagingFeed.getEntityById(id))) {
                        return true;
                    } else {
                        return false;
                    }
                });
            } else {
                if (this._model.rowsClickable(this._model.pagingFeed.getEntityById(selectedRows))) {
                    return selectedRows;
                }
            }
        }
        return selectedRows;
    }

    _setUserSelectedRows(selectedRows) {
        selectedRows = [].concat(selectedRows);
        this._model.setSelectedRows(this._applyNonClickableOnSelection(selectedRows));
    }

    _selectAllRows() {
        let that = this;
        applyEntityOrderSelection(this._model.pagingFeed.entityOrder);
        if (this._model.pagingFeed.fetchAllEntityIds) {
            this._model.setBusyVeil(true);
            this._model.pagingFeed
                .fetchAllEntityIds()
                .then(applyEntityOrderSelection, (err) => console.error(err))
                .then(() => this._model.setBusyVeil(false));
        }

        function applyEntityOrderSelection(selectedRows) {
            if (that._model._nonClickableRows) {
                selectedRows = selectedRows.filter((id) => {
                    if (that._model.rowsClickable(that._model.pagingFeed.getEntityById(id))) {
                        return true;
                    } else {
                        return false;
                    }
                });
            }
            that._model.setSelectedRows(selectedRows);
        }
    }

    /**
     * Capture an active state toggle for a grid row
     * @param eventData.row {String} - The id of the row that had an active state toggle
     * @param eventData.active {Boolean} - The active state
     * @param eventData.event {Event} - The mouse event that triggered the state change
     * @private
     */
    _onRowUserActive(eventData) {
        let rowId = eventData.row,
            active = eventData.active;
        if (!_.isUndefined(this._lockedRowComponents[rowId])) {
            this._lockedRowComponents[rowId].setActive(active);
        }
        if (!_.isUndefined(this._lockedRightRowComponents[rowId])) {
            this._lockedRightRowComponents[rowId].setActive(active);
        }
    }

    /**
     * Capture an active state toggle for a locked grid row
     * @param eventData.row {String} - The id of the row that had an active state toggle
     * @param eventData.active {Boolean} - The active state
     * @param eventData.event {Event} - The mouse event that triggered the state change
     * @private
     */
    _onLockedRowUserActive(eventData) {
        let rowId = eventData.row,
            active = eventData.active;
        this._rowComponents[rowId].setActive(active);
        this._lockedRightRowComponents[rowId].setActive(active);
    }
    _onLockedRightRowUserActive(eventData) {
        let rowId = eventData.row,
            active = eventData.active;
        this._rowComponents[rowId].setActive(active);
        this._lockedRowComponents[rowId].setActive(active);
    }

    /**
     * Fired when the user has double clicked a row
     * @param rowData {object}
     * @param event {event}
     * @private
     */
    _onRowUserDoubleClicked(rowData, event) {
        let currentRowSelectionId = event.currentTarget.component.getId();
        this._model._triggerUserRowDoubleClicked({
            selectedRow: currentRowSelectionId,
        });
    }

    /**
     * Fired when the user has selected an action in the cell
     * @param eventData
     * @private
     */
    _onRowAction(eventData) {
        this._model._triggerGridAction(eventData);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /**
     * Set the DOM id
     * @param newVal {string}
     * @private
     */
    _setId(newVal) {
        this._rootElem.classList.add(newVal);
        this._rootElem.dataset.id = newVal;
    }

    /**
     * Build the column display
     * @param newVal {object}
     * @private
     */
    _setColumns(newVal) {
        let columnOrder = this._model.getColumnOrder(),
            lockedColumns = this._model.getLockedColumns(),
            lockedRightColumns = this._model.getRightLockedColumns();
        for (let colKey in this._columnComponents) {
            this._columnComponents[colKey].removeAllListeners("UserSorted");
            this._columnComponents[colKey].removeAllListeners("UserReordered");
            this._columnComponents[colKey].removeAllListeners("UserLocked");
            this._columnComponents[colKey].removeAllListeners("UserResized");
            this._columnComponents[colKey].shutdown();
        }
        this._columnComponents = {};
        this._unlockedColumnsTotalWidth = 0;
        this._lockedHeaderRow.innerHTML = "";
        this._lockedRightHeaderRow.innerHTML = "";
        this._headerRow.innerHTML = "";
        columnOrder.forEach((columnKey) => {
            let columnConfig = newVal[columnKey];
            _.merge(columnConfig, {
                id: columnKey,
                showHeader: this._model.getShowHeader(),
                grid: this._model,
            });
            let column = new GridColumn(columnConfig);
            column.on(
                "UserReordered",
                (this._onColumnUserReordered = this._onColumnUserReordered.bind(this))
            );
            column.on(
                "UserLocked",
                (this._onColumnUserLocked = this._onColumnUserLocked.bind(this))
            );
            column.on(
                "UserSorted",
                (this._onColumnUserSorted = this._onColumnUserSorted.bind(this))
            );
            column.on(
                "UserResized",
                (this._onColumnUserResized = this._onColumnUserResized.bind(this))
            );
            if (column.getSort() !== "") {
                this._sortColumn = columnKey;
            }
            this._columnComponents[columnKey] = column;
            if (column.getLocked() === true) {
                this._lockedHeaderRow.appendChild(column.renderer.rootElement);
            } else if (column.getLockedRight() === true) {
                this._lockedRightHeaderRow.appendChild(column.renderer.rootElement);
            } else {
                this._unlockedColumnsTotalWidth += column.getWidth();
                this._headerRow.appendChild(column.renderer.rootElement);
            }
        });
        this._adjustGridBody();

        for (let rowKey in this._rowComponents) {
            this._rowComponents[rowKey].setColumnOrder(columnOrder, true);
            this._rowComponents[rowKey].setLockedColumns(lockedColumns, true);
            this._rowComponents[rowKey].setColumnComponents(this._columnComponents);
        }
        for (let rowKey in this._lockedRowComponents) {
            this._lockedRowComponents[rowKey].setColumnOrder(columnOrder, true);
            this._lockedRowComponents[rowKey].setLockedColumns(lockedColumns, true);
            this._lockedRowComponents[rowKey].setColumnComponents(this._columnComponents);
        }
        for (let rowKey in this._lockedRightRowComponents) {
            this._lockedRightRowComponents[rowKey].setColumnOrder(columnOrder, true);
            this._lockedRightRowComponents[rowKey].setLockedColumns(lockedRightColumns, true);
            this._lockedRightRowComponents[rowKey].setColumnComponents(this._columnComponents);
        }
    }

    /**
     * Removes any existing sort from columns other than the passed in column
     * @param column {component}
     * @private
     */
    _resetSortDisplay(column) {
        for (let colKey in this._columnComponents) {
            let col = this._columnComponents[colKey];
            if (column !== col) {
                col.setSort("");
            }
        }
    }

    _rebuildHeaderRow() {
        if (!_.isUndefined(this._headerRebuildTimeout)) {
            clearTimeout(this._headerRebuildTimeout);
        }
        this._headerRebuildTimeout = setTimeout(() => {
            let columnOrder = this._model.getColumnOrder(),
                lockedColumns = this._model.getLockedColumns(),
                lockedRightColumns = this._model.getRightLockedColumns(),
                unlockedColumns = _.difference(
                    columnOrder,
                    _.concat(lockedColumns, lockedRightColumns)
                );
            this._headerRow.innerHTML = "";
            this._lockedHeaderRow.innerHTML = "";
            this._lockedRightHeaderRow.innerHTML = "";
            lockedColumns.forEach((col) => {
                this._lockedHeaderRow.appendChild(this._columnComponents[col].renderer.rootElement);
            });
            unlockedColumns.forEach((col) => {
                this._headerRow.appendChild(this._columnComponents[col].renderer.rootElement);
            });
            lockedRightColumns.forEach((col) => {
                this._lockedRightHeaderRow.appendChild(
                    this._columnComponents[col].renderer.rootElement
                );
            });
            this._adjustGridBody();
        }, this._timeoutDuration);
    }

    /**
     * Order the column display
     * @param columnOrder {Array} - An Array of strings (column ids) representing the new column order
     * @private
     */
    _setColumnOrder(columnOrder) {
        this._rebuildHeaderRow();
        for (let rowKey in this._rowComponents) {
            this._rowComponents[rowKey].setColumnOrder(columnOrder);
        }
        for (let rowKey in this._lockedRowComponents) {
            this._lockedRowComponents[rowKey].setColumnOrder(columnOrder);
        }
        for (let rowKey in this._lockedRightRowComponents) {
            this._lockedRightRowComponents[rowKey].setColumnOrder(columnOrder);
        }
    }

    /**
     * Adjust the locked column display
     * @param lockedColumns {Array} - Array of column ids representing the order and quantity of any locked columns
     * @private
     */
    _setLockedColumns(/*lockedColumns*/) {
        let lockedColumns = this._model.getLockedColumns();
        let lockedRightColumns = this._model.getRightLockedColumns();

        for (let colId in this._columnComponents) {
            this._columnComponents[colId].setLocked(lockedColumns.indexOf(colId) !== -1);
            this._columnComponents[colId].setLockedRight(lockedRightColumns.indexOf(colId) !== -1);
        }

        this._rebuildHeaderRow();

        for (let rowKey in this._rowComponents) {
            this._rowComponents[rowKey].setLockedColumns(lockedColumns);
        }
        for (let rowKey in this._lockedRowComponents) {
            this._lockedRowComponents[rowKey].setLockedColumns(lockedColumns);
        }
        for (let rowKey in this._lockedRightRowComponents) {
            this._lockedRightRowComponents[rowKey].setLockedColumns(lockedRightColumns);
        }
    }

    /**
     * Show a column
     * @param columnId {String}
     * @private
     */
    _showColumn(columnId) {
        let columns = this._model.getColumns();
        if (!columns[columnId].hasOwnProperty("shown") || columns[columnId].shown) {
            return;
        }

        columns[columnId].shown = true;
        this._model.setColumns(columns);
    }

    /**
     * Hide a column
     * @param columnId {String}
     * @private
     */
    _hideColumn(columnId) {
        let columns = this._model.getColumns();
        if (columns[columnId].hasOwnProperty("shown") && !columns[columnId].shown) {
            return;
        }

        columns[columnId].shown = false;
        // columns[columnId].locked = false;
        // it brings inconsistency in user experience.
        this._model.setColumns(columns);
    }

    /**
     * Build the rows
     * @param newVal {object}
     * @param triggerSort {boolean}
     * @private
     */
    _setEntities(newVal) {
        let currentPagePosition,
            currentRowKeys = Object.keys(this._rowComponents),
            newRowKeys = Object.keys(newVal),
            rowsToDelete = _.difference(currentRowKeys, newRowKeys),
            groups = this._model.sortGroupValues(),
            groupsExpanded = this._model.expandedGroups || [],
            groupBy = this._model._groupBy,
            groupValuePath = this._model.getColumnValuePath(groupBy),
            lastShownGroup = null,
            replacementValue =
                this._model._groupingValuesFeed &&
                this._model._groupingValuesFeed._replacementValue;

        if (groupsExpanded.indexOf(replacementValue) > -1) {
            groupsExpanded = groupsExpanded.sort();
            groupsExpanded = _.uniq(
                groupsExpanded.filter((i) => [null, undefined].indexOf(i) === -1)
            );
            groupsExpanded.forEach((i) => {
                let filteredList = Object.values(newVal).filter((j) => {
                    return i === replacementValue
                        ? _.includes(["", null, undefined], _.get(j, groupValuePath))
                        : _.get(j, groupValuePath) === i;
                });
                filteredList.sort((i, j) => i.pagePos > j.pagePos);
            });
        }

        let allEntitiesByPagePos = _.chain({})
            .merge(this._rowComponents, newVal)
            .reduce(
                (allEntitiesByPagePos, entity) =>
                    _.set(allEntitiesByPagePos, entity.pagePos, entity),
                {}
            )
            .value();

        const getEntityGroupValue = (entity) => {
            if (
                (_.isUndefined(_.get(entity, groupValuePath)) ||
                    _.isNull(_.get(entity, groupValuePath)) ||
                    _.get(entity, groupValuePath) === "") &&
                replacementValue
            ) {
                return replacementValue || null;
            }
            return _.get(entity, groupValuePath);
        };

        const placedGroupRows = new Map();
        const prepareAddGroupRow = (
            groupBy,
            groupHeader,
            gridHeaderIndex,
            expanded = false,
            anchored = false
        ) => {
            if (
                (_.isUndefined(groupHeader) ||
                    _.isNull(groupHeader) ||
                    groupHeader === "" ||
                    groupHeader === "undefined") &&
                replacementValue
            ) {
                groupHeader = _.get(this._model._groupingValuesFeed, "_replacementValue");
            }

            // Group rows are keyed by header text alone, so a repeat placement just moves the row.
            // The anchored position (above an expanded group's first row) wins over estimates.
            const placedRow = placedGroupRows.get(String(groupHeader));
            if (placedRow && (placedRow.anchored || !anchored)) {
                return;
            }
            placedGroupRows.set(String(groupHeader), {anchored});

            expanded = expanded || groupsExpanded.includes(groupHeader);
            const groupRowKey = this._addGroupRow(groupBy, groupHeader, gridHeaderIndex, expanded);
            //lastShownGroup = groupHeader;
            if (rowsToDelete.includes(groupRowKey)) {
                rowsToDelete.splice(rowsToDelete.indexOf(groupRowKey), 1);
            }
        };

        this._updateGroupingColumnHeader();

        // _.get(undefined, "pagePos", 0) is also 0, so check firstEntity explicitly — prepending
        // on a mid-window paint strands headers. Raw "" is absent from `groups`, so resolve it.
        const firstEntity = allEntitiesByPagePos[0];
        if (groupBy && (_.isEmpty(newVal) || (firstEntity && firstEntity.pagePos === 0))) {
            const collapsedGroups = _.isEmpty(newVal)
                ? groups
                : groups.slice(0, groups.indexOf(getEntityGroupValue(firstEntity)));
            collapsedGroups.forEach((groupHeader, idx) => {
                prepareAddGroupRow(groupBy, groupHeader, idx);
            });
        }

        _.sortBy(newRowKeys, (key) => newVal[key].pagePos).forEach((entityId) => {
            const entity = newVal[entityId],
                entityPagePos = entity.pagePos,
                prevEntity = allEntitiesByPagePos[entityPagePos - 1],
                currentGroup = getEntityGroupValue(entity),
                prevGroup = getEntityGroupValue(prevEntity),
                entityShift = groups.indexOf(currentGroup) + 1,
                entityUpdatedPosition = entityPagePos + entityShift;

            lastShownGroup = prevEntity ? prevGroup : null;

            if (groupBy && (entityPagePos === 0 || (prevEntity && prevGroup !== currentGroup))) {
                const currentGroupIndex = groups.indexOf(currentGroup),
                    lastGroupIndex =
                        lastShownGroup === null
                            ? currentGroupIndex
                            : groups.indexOf(lastShownGroup),
                    collapsedGroups = groups.slice(lastGroupIndex + 1, currentGroupIndex);

                //display collapsed groups on the page
                collapsedGroups.forEach((groupHeader, idx) => {
                    prepareAddGroupRow(
                        groupBy,
                        groupHeader,
                        idx + lastGroupIndex + entityPagePos + 1
                    );
                });

                //add grouping row
                let gridHeaderIndex = entityUpdatedPosition - 1;
                prepareAddGroupRow(groupBy, currentGroup, gridHeaderIndex, true, true);
            }
            if (_.isUndefined(this._rowComponents[entityId])) {
                this._addEntity(entity, entityUpdatedPosition);
            } else {
                if (!_.isUndefined(entity.pagePos)) {
                    currentPagePosition = _.get(this._rowComponents[entityId], "_pageIndex");
                    if (currentPagePosition !== entity.pagePos + entityShift) {
                        this._moveRow(entityId, entity.pagePos + entityShift);
                    }
                }
                if (entity !== this._rowComponents[entityId].getEntity()) {
                    this._updateRowEntity(entityId, entity);
                }
            }

            if (groupBy && entityPagePos === this._model.getOriginalTotalEntities() - 1) {
                // we are on the last position of the list.
                // append groups to the grid
                const collapsedGroups = groups.slice(entityShift);
                collapsedGroups.forEach((groupHeader, idx) => {
                    prepareAddGroupRow(groupBy, groupHeader, idx + entityUpdatedPosition + 1);
                });
            }
        });

        // NOTE: USE TIMEOUT TO ALLOW ROWS TO BE ADDED/PAINTED BEFORE REMOVED/PAINTED
        this._pendingRowDeletes = new Set(rowsToDelete);
        setTimeout(() => {
            rowsToDelete.forEach((rowKey) => {
                this._deleteRow(rowKey);
                this._deleteLockedRow(rowKey);
                this._deleteLockedRightRow(rowKey);
            });
            // this._keepFocus();
            this._pendingRowDeletes = undefined;
            this._updateSkeletonVisibility(this._scrollTopPosition);
        });
        this._updateSkeletonVisibility(this._scrollTopPosition);
        this._adjustGridBody();
    }

    /**
     * Sort the grid based on the passed in column
     * @param columnId {String}
     * @param sort {String}
     * @private
     */
    _setGridSorted(columnId, sort) {
        let column = this._columnComponents[columnId];
        this._sortColumn = columnId;
        this._sort = sort;
        this._resetSortDisplay(column, this._sort);

        if (column.getSort() !== sort) {
            column.setSort(sort);
        }

        this._model.setUserSorted({
            sortColumn: this._sortColumn,
            sort: this._sort,
        });
    }

    /**
     * Add an entity row into the grid
     * @param entity {object} - The entity to add to the grid
     * @param pageIndex {Number} - The position of the entity in the set of pages used to build the pagination display
     * @private
     */
    _addEntity(entity, pageIndex) {
        let lockedColumns = this._model.getLockedColumns(),
            lockedRightColumns = this._model.getRightLockedColumns(),
            totalLockedColumn = _.concat(lockedColumns, lockedRightColumns),
            rowKey = entity.getId(),
            rowTopValue = 0;
        if (!_.isUndefined(pageIndex)) {
            rowTopValue = pageIndex * this._rowHeight;
        }
        let row = new UnlockedGridRow({
            id: rowKey,
            columnOrder: this._model.getColumnOrder(),
            lockedColumns: totalLockedColumn,
            entity: entity,
            top: rowTopValue,
            columnComponents: this._columnComponents,
            grid: this._model,
            pageIndex: pageIndex,
            even: pageIndex % 2,
            rightLockedColumns: lockedRightColumns,
            allowDragNDrop: this.model._allowDragNDrop,
        });
        this._rowComponents[rowKey] = row;

        if (this._model.rowsClickable(entity)) {
            this._rowComponents[rowKey].addListener(
                "RowUserSelected",
                (this._onRowUserSelected = this._onRowUserSelected.bind(this))
            );
            this._rowComponents[rowKey].addListener(
                "RowUserActive",
                (this._onRowUserActive = this._onRowUserActive.bind(this))
            );
            this._rowComponents[rowKey].addListener(
                "RowAction",
                (this._onRowAction = this._onRowAction.bind(this))
            );
        } else {
            this._rowComponents[rowKey].getRenderer().getRootElement().classList.add("frozen-row");
        }
        this._rowComponents[rowKey].addListener(
            "RowUserDoubleClicked",
            (this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this))
        );
        this._insertRow(row /*, this._rowComponents[previousEntityId] */);

        let lockedRow = new LockedGridRow({
            id: rowKey,
            columnOrder: this._model.getColumnOrder(),
            lockedColumns: lockedColumns,
            entity: entity,
            top: rowTopValue,
            columnComponents: this._columnComponents,
            grid: this._model,
            pageIndex: pageIndex,
            even: pageIndex % 2,
            allowDragNDrop: this.model._allowDragNDrop,
        });
        this._lockedRowComponents[rowKey] = lockedRow;

        if (this._model.rowsClickable(entity)) {
            this._lockedRowComponents[rowKey].addListener(
                "RowUserSelected",
                (this._onRowUserSelected = this._onRowUserSelected.bind(this))
            );
            this._lockedRowComponents[rowKey].addListener(
                "RowUserActive",
                (this._onLockedRowUserActive = this._onLockedRowUserActive.bind(this))
            );

            this._lockedRowComponents[rowKey].addListener(
                "RowAction",
                (this._onRowAction = this._onRowAction.bind(this))
            );
        } else {
            this._lockedRowComponents[rowKey]
                .getRenderer()
                .getRootElement()
                .classList.add("frozen-row");
        }
        this._lockedRowComponents[rowKey].addListener(
            "RowUserDoubleClicked",
            (this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this))
        );

        this._insertLockedRow(lockedRow /*, this._lockedRowComponents[previousEntityId] */);

        let lockedRightRow = new LockedGridRow({
            id: rowKey,
            columnOrder: this._model.getColumnOrder(),
            lockedColumns: lockedRightColumns,
            entity: entity,
            top: rowTopValue,
            columnComponents: this._columnComponents,
            grid: this._model,
            pageIndex: pageIndex,
            even: pageIndex % 2,
            allowDragNDrop: this.model._allowDragNDrop,
        });

        if (this._model.rowsClickable(entity)) {
            lockedRightRow
                .addListener(
                    "RowUserSelected",
                    (this._onRowUserSelected = this._onRowUserSelected.bind(this))
                )
                .addListener(
                    "RowUserActive",
                    (this._onLockedRightRowUserActive = this._onLockedRightRowUserActive.bind(this))
                )
                .addListener("RowAction", (this._onRowAction = this._onRowAction.bind(this)));
        } else {
            lockedRightRow.getRenderer().getRootElement().classList.add("frozen-row");
        }
        lockedRightRow.addListener(
            "RowUserDoubleClicked",
            (this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this))
        );

        this._lockedRightRowComponents[rowKey] = lockedRightRow;
        this._insertRightLockedRow(
            lockedRightRow /*, this._lockedRowComponents[previousEntityId] */
        );

        this._adjustGridBody();
    }

    _addGroupRow(groupBy, header, index = 0, expanded = false) {
        //const rowKey = `${groupBy}_${header}`;
        const rowKey = String(header);

        if (_.has(this._lockedRowComponents, rowKey)) {
            this._rowComponents[rowKey].setExpanded(expanded);
            this._lockedRowComponents[rowKey].setExpanded(expanded);
            this._moveRow(rowKey, index);
        } else {
            let lockedColumns = this._model.getLockedColumns(),
                lockedRightColumns = this._model.getRightLockedColumns(),
                totalLockedColumn = _.concat(lockedColumns, lockedRightColumns);
            const groupEntity = this._model.createGroupingEntity(
                groupBy,
                rowKey,
                header,
                index,
                expanded
            );
            const rowData = {
                id: rowKey,
                columnOrder: this._model.getColumnOrder(),
                lockedColumns: totalLockedColumn,
                entity: groupEntity,
                top: index * this._rowHeight,
                columnComponents: this._columnComponents,
                grid: this._model,
                isGroupHeader: true,
                pageIndex: index,
                expanded: expanded,
                rightLockedColumns: lockedRightColumns,
                allowDragNDrop: this.model._allowDragNDrop,
                //even: pageIndex % 2
            };
            let row = new UnlockedGridGroupRow(
                Object.assign({}, rowData, {lockedColumns: totalLockedColumn})
            );
            let lockedRow = new LockedGridGroupRow(
                Object.assign({}, rowData, {lockedColumns: lockedColumns})
            );
            let lockedRightRow = new LockedGridGroupRow(
                Object.assign({}, rowData, {lockedColumns: lockedRightColumns})
            );

            row.addListener(
                "RowUserActive",
                (this._onRowUserActive = this._onRowUserActive.bind(this))
            );
            //this._rowComponents[rowKey].addListener('RowUserSelected', this._onRowUserSelected = this._onRowUserSelected.bind(this));
            //this._rowComponents[rowKey].addListener('RowUserDoubleClicked', this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this));
            //this._rowComponents[rowKey].addListener('RowAction', this._onRowAction = this._onRowAction.bind(this));

            lockedRow.addListener(
                "RowUserActive",
                (this._onLockedRowUserActive = this._onLockedRowUserActive.bind(this))
            );
            //this._lockedRowComponents[rowKey].addListener('RowUserSelected', this._onRowUserSelected = this._onRowUserSelected.bind(this));
            //this._lockedRowComponents[rowKey].addListener('RowUserDoubleClicked', this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this));
            //this._lockedRowComponents[rowKey].addListener('RowAction', this._onRowAction = this._onRowAction.bind(this));

            lockedRightRow.addListener(
                "RowUserActive",
                (this._onLockedRightRowUserActive = this._onLockedRightRowUserActive.bind(this))
            );
            //this._lockedRowComponents[rowKey].addListener('RowUserSelected', this._onRowUserSelected = this._onRowUserSelected.bind(this));
            //this._lockedRowComponents[rowKey].addListener('RowUserDoubleClicked', this._onRowUserDoubleClicked = this._onRowUserDoubleClicked.bind(this));
            //this._lockedRowComponents[rowKey].addListener('RowAction', this._onRowAction = this._onRowAction.bind(this));

            this._rowComponents[rowKey] = row;
            this._lockedRowComponents[rowKey] = lockedRow;
            this._lockedRightRowComponents[rowKey] = lockedRightRow;

            this._insertRow(row);
            this._insertLockedRow(lockedRow);
            this._insertRightLockedRow(lockedRightRow);
        }
        return rowKey;
    }

    /**
     * Insert or append into the grid body the passed in Row Component
     * @param rowComponent {GridRowComponent} - The Row Component to append
     * @param [previousRowComponent] {GridRowComponent} - The Row Component appearing before this row component in the grid
     * @private
     */
    _insertRow(rowComponent, previousRowComponent) {
        if (!_.isUndefined(previousRowComponent)) {
            this._gridBody.insertBefore(
                rowComponent.renderer.rootElement,
                previousRowComponent.renderer.rootElement.nextSibling
            );
        } else {
            this._gridBody.appendChild(rowComponent.renderer.rootElement);
        }
    }

    /**
     * Insert or append into the locked grid body the passed in Row Component
     * @param rowComponent {LockedGridRowComponent} - The Row Component to append
     * @param [previousRowComponent] {LockedGridRowComponent} - The Row Component appearing before this row component in the grid
     * @private
     */
    _insertLockedRow(rowComponent, previousRowComponent) {
        if (!_.isUndefined(previousRowComponent)) {
            this._lockedGridBody.insertBefore(
                rowComponent.renderer.rootElement,
                previousRowComponent.renderer.rootElement.nextSibling
            );
        } else {
            this._lockedGridBody.appendChild(rowComponent.renderer.rootElement);
        }
    }

    _insertRightLockedRow(rowComponent, previousRowComponent) {
        if (!_.isUndefined(previousRowComponent)) {
            this._lockedRightGridBody.insertBefore(
                rowComponent.renderer.rootElement,
                previousRowComponent.renderer.rootElement.nextSibling
            );
        } else {
            this._lockedRightGridBody.appendChild(rowComponent.renderer.rootElement);
        }
    }

    /**
     * Move an existing row to a new position in the current page
     * @param rowKey {String} - The entity ID to be moved
     * @param newPageIndex {Number} - The new position of the entity in the set of pages used to build the pagination display
     * @private
     */
    _moveRow(rowKey, newPageIndex) {
        if (
            !_.isUndefined(rowKey) &&
            !_.isUndefined(this._rowComponents[rowKey]) &&
            _.isInteger(newPageIndex)
        ) {
            let rowTopValue = newPageIndex * this._rowHeight,
                even = newPageIndex % 2;

            this._rowComponents[rowKey].setTop(rowTopValue);
            this._rowComponents[rowKey].setPageIndex(newPageIndex);
            this._rowComponents[rowKey].setEven(even);
            //this._rowComponents[rowKey].renderer.rootElement.remove();
            //this._insertRow(this._rowComponents[rowKey]);

            this._lockedRowComponents[rowKey].setTop(rowTopValue);
            this._lockedRowComponents[rowKey].setPageIndex(newPageIndex);
            this._lockedRowComponents[rowKey].setEven(even);
            //this._lockedRowComponents[rowKey].renderer.rootElement.remove();
            //this._insertLockedRow(this._lockedRowComponents[rowKey]);

            this._lockedRightRowComponents[rowKey].setTop(rowTopValue);
            this._lockedRightRowComponents[rowKey].setPageIndex(newPageIndex);
            this._lockedRightRowComponents[rowKey].setEven(even);

            //ToDo check if commented lines are really needed
        }
    }

    /**
     * Update a row Entity
     * @param {string} rowKey - the key of the row bo be updated
     * @param {Object} newEntity - new entity
     * @private
     */
    _updateRowEntity(rowKey, newEntity) {
        if (this._rowComponents[rowKey]) {
            this._rowComponents[rowKey].setEntity(newEntity);
        }
        if (this._lockedRowComponents[rowKey]) {
            this._lockedRowComponents[rowKey].setEntity(newEntity);
        }
    }

    /**
     * Delete a row
     * @param rowKey {string}
     * @private
     */
    _deleteRow(rowKey) {
        if (!_.isUndefined(this._rowComponents[rowKey])) {
            this._rowComponents[rowKey].removeListener("RowUserSelected", this._onRowUserSelected);
            this._rowComponents[rowKey].removeListener("RowUserActive", this._onRowUserActive);
            this._rowComponents[rowKey].removeListener(
                "RowUserDoubleClicked",
                this._onRowUserDoubleClicked
            );
            this._rowComponents[rowKey].removeListener("RowAction", this._onRowAction);
            this._rowComponents[rowKey].shutdown();
            delete this._rowComponents[rowKey];
        }
        this._adjustGridBody();
    }

    /**
     * Delete a locked row
     * @param rowKey {string}
     * @private
     */
    _deleteLockedRow(rowKey) {
        if (!_.isUndefined(this._lockedRowComponents[rowKey])) {
            this._lockedRowComponents[rowKey].removeListener(
                "RowUserSelected",
                this._onRowUserSelected
            );
            this._lockedRowComponents[rowKey].removeListener(
                "RowUserActive",
                this._onLockedRowUserActive
            );
            this._lockedRowComponents[rowKey].removeListener(
                "RowUserDoubleClicked",
                this._onRowUserDoubleClicked
            );
            this._lockedRowComponents[rowKey].removeListener("RowAction", this._onRowAction);
            this._lockedRowComponents[rowKey].shutdown();
            delete this._lockedRowComponents[rowKey];
        }
        this._adjustGridBody();
    }
    /**
     * Delete Right locked row
     * @param rowKey {string}
     * @private
     */
    _deleteLockedRightRow(rowKey) {
        if (!_.isUndefined(this._lockedRightRowComponents[rowKey])) {
            this._lockedRightRowComponents[rowKey].removeListener(
                "RowUserSelected",
                this._onRowUserSelected
            );
            this._lockedRightRowComponents[rowKey].removeListener(
                "RowUserActive",
                this._onLockedRightRowUserActive
            );
            this._lockedRightRowComponents[rowKey].removeListener(
                "RowUserDoubleClicked",
                this._onRowUserDoubleClicked
            );
            this._lockedRightRowComponents[rowKey].removeListener("RowAction", this._onRowAction);
            this._lockedRightRowComponents[rowKey].shutdown();
            delete this._lockedRightRowComponents[rowKey];
        }
        this._adjustGridBody();
    }

    /**
     * Select the passed rows
     * @param newVal {array}
     * @private
     */
    _setSelectedRows(newVal) {
        const isSelected = _.memoize((rowKey) => _.includes(newVal, rowKey));
        for (let rowKey in this._rowComponents) {
            this._rowComponents[rowKey].setSelected(isSelected(rowKey));
        }
        for (let rowKey in this._lockedRowComponents) {
            this._lockedRowComponents[rowKey].setSelected(isSelected(rowKey));
        }
        for (let rowKey in this._lockedRightRowComponents) {
            this._lockedRightRowComponents[rowKey].setSelected(isSelected(rowKey));
        }
        isSelected.cache.delete();

        /*
        newVal.forEach((rowId) => {
            if (!_.isUndefined(this._rowComponents[rowId])) {
                this._rowComponents[rowId].setSelected(true);
            }
            if (!_.isUndefined(this._lockedRowComponents[rowId])) {
                this._lockedRowComponents[rowId].setSelected(true);
            }
            if (!_.isUndefined(this._lockedRightRowComponents[rowId])) {
                this._lockedRightRowComponents[rowId].setSelected(true);
            }
        });
*/
    }

    /**
     * Pass the value to each column
     * @param newVal {boolean}
     * @private
     */
    _setShowHeader(newVal) {
        for (let columnKey in this._columnComponents) {
            this._columnComponents[columnKey].setShowHeader(newVal);
        }
    }

    /**
     * Set or remove focus on the textfield
     * @param newVal {boolean}
     * @private
     */
    _setFocus(newVal) {
        if (newVal === true) {
            this._rootElem.focus();
        } else {
            this._rootElem.blur();
        }
    }

    // TODO Decommissioned - Replaced by getRangeSelection() from pagingDeviceFeed
    // _getRangeSelection(currentSelection, previousSelection){
    //     let inSelection = false,
    //         selection = [],
    //         entityOrder = this._model.pagingFeed.entityOrder;
    //     entityOrder.forEach((entityKey) => {
    //         if (entityKey === currentSelection || entityKey === previousSelection) {
    //             if (inSelection === false) {
    //                 inSelection = true;
    //             } else {
    //                 selection.push(entityKey);
    //                 inSelection = false;
    //             }
    //         }
    //         if (inSelection === true) {
    //             selection.push(entityKey);
    //         }
    //     });
    //     return selection;
    // }

    /**
     * Calculations to make adjustments to the grid body DOM elements
     * @private
     */
    _adjustGridBody() {
        if (_.isUndefined(this._gridBodyAdjustmentTimeout)) {
            this._gridBodyAdjustmentTimeout = setTimeout(() => {
                this._adjustLockedGridBodyColumnMargin();
                this._adjustGridBodyHeightWidth();
                this._adjustGridBodyScrollBar();
                this._gridBodyAdjustmentTimeout = undefined;
            }, this._timeoutDuration);
        }
    }

    /**
     * Check if the horizontal scrollbar is showing on the unlocked grid body and adjust the margin
     * of the locked grid body accordingly
     * @private
     */
    _adjustLockedGridBodyColumnMargin() {
        let clientWidth = this._gridBodyContainer.clientWidth,
            scrollWidth = this._gridBodyContainer.scrollWidth;
        if (scrollWidth > clientWidth) {
            this._lockedGridBodyContainer.style.marginBottom = this._scrollbarHeight / 10 + "rem";
            this._lockedRightGridBodyContainer.style.marginBottom =
                this._scrollbarHeight / 10 + "rem";
        } else {
            this._lockedGridBodyContainer.style.marginBottom = 0;
            this._lockedRightGridBodyContainer.style.marginBottom = 0;
        }
    }

    _adjustGridBodyScrollBar() {
        if (this._model._lockedRightColumnsCache.length > 0) {
            this._lockedRightGridBodyContainer.style.overflowY = "scroll";
            this._gridBodyContainer.style.overflowY = "hidden";
        } else {
            this._lockedRightGridBodyContainer.style.overflowY = "hidden";
            this._gridBodyContainer.style.overflowY = "scroll";
        }
    }
    /**
     * Adjust unlocked grid body height based on added/removed rows, or adjust its width based on
     * added/removed/resized columns
     * @private
     */
    _adjustGridBodyHeightWidth() {
        let gridBodyHeight = (this._totalEntities * this._rowHeight) / 10 + "rem",
            lockedColumns = [].concat(
                this._model.getLockedColumns(),
                this._model.getRightLockedColumns()
            ),
            allColumns = this._model.getColumns(),
            visibleColumns = [],
            unlockedColumns;
        for (let column in allColumns) {
            if (allColumns[column].shown !== false) {
                visibleColumns.push(column);
            }
        }
        unlockedColumns = _.difference(visibleColumns, lockedColumns);
        this._unlockedColumnsTotalWidth = 0;

        unlockedColumns.forEach((column) => {
            this._unlockedColumnsTotalWidth += this._columnComponents[column].getWidth();
        });
        this._gridBody.style.width = this._unlockedColumnsTotalWidth / 10 + "rem";
        this._gridBody.style.height = gridBodyHeight;
        this._lockedGridBody.style.height = gridBodyHeight;
        this._lockedRightGridBody.style.height = gridBodyHeight;
    }

    /**
     * Triggered when the grid has been scrolled by the user
     * @param eventData.scrollTop {Number} - The pixel value of the distance the grid body has been scrolled from the top
     * @param eventData.scrollLeft {Number} - The pixel value of the distance the grid body has been scrolled from the left
     * @param eventData.event {Event} - The DOM scroll event
     * @private
     */
    _checkPagePosition(topPosition) {
        if (!_.isUndefined(this._pagePositionCheckTimeout)) {
            clearTimeout(this._pagePositionCheckTimeout);
        }
        this._pagePositionCheckTimeout = setTimeout(() => {
            let maxTopPosition = this._activePage * this._rowHeight * this._pageSize,
                minTopPosition = (this._activePage - 1) * this._rowHeight * this._pageSize,
                scrollTop = topPosition,
                pagingFeed = this._model.pagingFeed;
            if (scrollTop > maxTopPosition) {
                for (
                    let iterativePage = this._activePage;
                    iterativePage <= this._lastPage;
                    iterativePage++
                ) {
                    let min = iterativePage * this._rowHeight * this._pageSize,
                        max = (iterativePage + 1) * this._rowHeight * this._pageSize;
                    if (scrollTop >= min && scrollTop <= max) {
                        pagingFeed.setActivePage(iterativePage + 1);
                        break;
                    }
                }
            } else if (scrollTop < minTopPosition) {
                for (
                    let iterativePage = this._activePage;
                    iterativePage >= this._firstPage;
                    iterativePage--
                ) {
                    let min = (iterativePage - 1) * this._rowHeight * this._pageSize,
                        max = iterativePage * this._rowHeight * this._pageSize;
                    if (scrollTop >= min && scrollTop <= max) {
                        pagingFeed.setActivePage(iterativePage);
                        break;
                    }
                }
            }
            this._updateSkeletonVisibility(scrollTop);
            this._pagePositionCheckTimeout = undefined;
        }, this._timeoutDuration);
    }

    /**
     * Collect the visual slot indexes currently occupied by rendered rows
     * (entity rows and group header rows alike), skipping rows pending deletion
     * @returns {Set<Number>}
     * @private
     */
    _getOccupiedSlots() {
        const occupied = new Set(),
            pendingDelete = this._pendingRowDeletes;
        _.forEach(this._rowComponents, (row, rowKey) => {
            if (pendingDelete && pendingDelete.has(rowKey)) {
                return;
            }
            const pageIndex = row.getPageIndex();
            if (_.isInteger(pageIndex)) {
                occupied.add(pageIndex);
            }
        });
        return occupied;
    }

    /**
     * Show the loading skeleton over the empty part of the viewport, or hide it
     * when every visible slot holds a rendered row
     * @param scrollTop {Number} - current vertical scroll position of the grid body
     * @private
     */
    _updateSkeletonVisibility(scrollTop) {
        if (_.isUndefined(this._model) || _.isUndefined(this._model.pagingFeed)) {
            return;
        }
        const viewportHeight = this._gridBodyContainer.clientHeight;
        if (!viewportHeight) {
            return;
        }
        const firstVisibleSlot = Math.floor(scrollTop / this._rowHeight),
            lastVisibleSlot =
                Math.min(
                    firstVisibleSlot + Math.ceil(viewportHeight / this._rowHeight) + 2,
                    this._totalEntities
                ) - 1,
            occupied = this._getOccupiedSlots();
        let emptyStart = -1,
            emptyEnd = -1;
        for (let slot = firstVisibleSlot; slot <= lastVisibleSlot; slot++) {
            if (!occupied.has(slot)) {
                if (emptyStart === -1) {
                    emptyStart = slot;
                }
                emptyEnd = slot;
            }
        }
        if (emptyStart === -1) {
            this._hideSkeleton();
        } else {
            this._showSkeleton(emptyStart, emptyEnd - emptyStart + 1);
        }
    }

    /**
     * Display shimmering placeholder rows over the given un-cached row range
     * @param firstRow {Number} - absolute row index the skeleton starts at
     * @param rowCount {Number} - number of skeleton rows to display
     * @private
     */
    _showSkeleton(firstRow, rowCount) {
        if (rowCount < 1) {
            return;
        }
        const top = firstRow * this._rowHeight;

        if (_.isUndefined(this._skeletonFeedListener)) {
            this._skeletonFeedListener = () =>
                this._updateSkeletonVisibility(this._scrollTopPosition);
            this._model.pagingFeed.on("RefreshLinesNumber", this._skeletonFeedListener);
        }
        clearTimeout(this._skeletonHideTimeout);
        this._skeletonHideTimeout = setTimeout(() => this._hideSkeleton(), 10000);

        if (
            this._skeletonLayers.unlocked.classList.contains("visible") &&
            this._skeletonRowCount === rowCount
        ) {
            if (this._skeletonTop !== top) {
                _.forEach(this._skeletonLayers, (layer) => {
                    layer.style.top = top / 10 + "rem";
                    layer.classList.toggle("first-odd", firstRow % 2 === 1);
                });
                this._skeletonTop = top;
            }
            return;
        }

        const allColumns = this._model.getColumns(),
            lockedColumns = this._model.getLockedColumns(),
            lockedRightColumns = this._model.getRightLockedColumns(),
            isShown = (columnId) =>
                allColumns[columnId] &&
                allColumns[columnId].shown !== false &&
                !_.isUndefined(this._columnComponents[columnId]),
            visibleLocked = lockedColumns.filter(isShown),
            visibleLockedRight = lockedRightColumns.filter(isShown),
            visibleUnlocked = _.difference(
                this._model.getColumnOrder(),
                [].concat(lockedColumns, lockedRightColumns)
            ).filter(isShown);

        this._buildSkeletonLayer(
            this._skeletonLayers.unlocked,
            this._gridBody,
            visibleUnlocked,
            rowCount,
            firstRow,
            top
        );
        this._buildSkeletonLayer(
            this._skeletonLayers.locked,
            this._lockedGridBody,
            visibleLocked,
            rowCount,
            firstRow,
            top
        );
        this._buildSkeletonLayer(
            this._skeletonLayers.lockedRight,
            this._lockedRightGridBody,
            visibleLockedRight,
            rowCount,
            firstRow,
            top
        );
        this._skeletonTop = top;
        this._skeletonRowCount = rowCount;
    }

    /**
     * Fill a skeleton layer with placeholder rows mirroring the visible column widths
     * @private
     */
    _buildSkeletonLayer(layer, gridBody, columnIds, rowCount, firstRow, top) {
        layer.innerHTML = "";
        layer.style.top = top / 10 + "rem";
        layer.classList.toggle("first-odd", firstRow % 2 === 1);
        for (let rowIdx = 0; rowIdx < rowCount; rowIdx++) {
            const row = document.createElement("skeleton-row");
            columnIds.forEach((columnId, colIdx) => {
                const cell = document.createElement("skeleton-cell");
                cell.style.width = this._columnComponents[columnId].getWidth() / 10 + "rem";
                if (columnId !== "grouping") {
                    const bar = document.createElement("skeleton-bar");
                    bar.style.width = 55 + ((rowIdx * 7 + colIdx * 13) % 36) + "%";
                    cell.appendChild(bar);
                }
                row.appendChild(cell);
            });
            layer.appendChild(row);
        }
        layer.classList.add("visible");
        if (layer.parentElement !== gridBody) {
            gridBody.appendChild(layer);
        }
    }

    _hideSkeleton() {
        clearTimeout(this._skeletonHideTimeout);
        this._skeletonHideTimeout = undefined;
        this._skeletonTop = undefined;
        this._skeletonRowCount = undefined;
        if (!_.isUndefined(this._skeletonFeedListener) && this._model && this._model.pagingFeed) {
            this._model.pagingFeed.removeListener("RefreshLinesNumber", this._skeletonFeedListener);
        }
        this._skeletonFeedListener = undefined;
        _.forEach(this._skeletonLayers, (layer) => {
            layer.classList.remove("visible");
            layer.innerHTML = "";
        });
    }

    _resizeColumn(eventData) {
        if (!this._columnComponents[eventData.column]) {
            return;
        }

        if (this._columnComponents[eventData.column].getWidth() !== eventData.width) {
            this._columnComponents[eventData.column].setWidth(eventData.width);
        }
        for (let row in this._rowComponents) {
            this._rowComponents[row].columnWidthUpdate(eventData);
        }
        for (let row in this._lockedRowComponents) {
            this._lockedRowComponents[row].columnWidthUpdate(eventData);
        }
        this._adjustGridBody();
    }

    _log(...args) {
        console.log(`Entity grid Renderer ${this.model._gridKey || ""}`, ...args);
    }

    _updateGroupingColumnHeader(groupingData = {}) {
        const {groupBy = this._model._groupBy} = groupingData;
        const columns = this._model.getColumns();
        const groupByColumn = columns[groupBy];
        const groupColumn = this._columnComponents.grouping;
        if (groupColumn && groupByColumn) {
            groupColumn.setLabel(`Group by ${groupByColumn.label}`);
            groupColumn.setDescription(`Group by ${groupByColumn.label}`);
        } else if (groupColumn) {
            groupColumn.setLabel("Group");
            groupColumn.setDescription("Group");
        }
    }

    /**
     * Freeze a row
     * @param {Object} entityId - the id of the row to freeze
     * @private
     */
    _freezeRow(entityId) {
        const rowComponent = this._rowComponents[entityId];
        if (!rowComponent) {
            return;
        }
        rowComponent.removeAllListeners("RowUserSelected");
        rowComponent.removeAllListeners("RowUserActive");
        rowComponent.removeAllListeners("RowAction");
        rowComponent.getRenderer().getRootElement().classList.add("frozen-row");
    }

    /**
     * Unfreeze a row
     * @param {Object} entityId - the id of the row to unfreeze
     * @private
     */
    _unfreezeRow(entityId) {
        const rowComponent = this._rowComponents[entityId];
        if (!rowComponent) {
            return;
        }
        rowComponent.addListener(
            "RowUserSelected",
            (this._onRowUserSelected = this._onRowUserSelected.bind(this))
        );
        rowComponent.addListener(
            "RowUserActive",
            (this._onLockedRightRowUserActive = this._onLockedRightRowUserActive.bind(this))
        );
        rowComponent.addListener("RowAction", (this._onRowAction = this._onRowAction.bind(this)));
        rowComponent.getRenderer().getRootElement().classList.remove("frozen-row");
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = EntityGridRenderer;
